import { useContext } from 'react';

import { PurchaseOrderFormContext } from '~/orders/contexts/PurchaseOrderFormContext';

import {
  FinancialDetailsSection,
  SellerAdditionalDetailsAndDocumentsSection,
  SellerDealDetailsSection,
  SellerLogisticsSection,
  SellerMaterialDetailsSection,
  SellerPartiesSection,
} from '..';

export const PurchaseOrderFormSections = () => {
  const { documents: uploadedDocuments } = useContext(PurchaseOrderFormContext);

  return (
    <>
      <SellerPartiesSection />
      <SellerMaterialDetailsSection />
      <SellerDealDetailsSection />
      <SellerLogisticsSection />
      <FinancialDetailsSection isBuyer={false} currencyPriceName="seller_currency" />
      <SellerAdditionalDetailsAndDocumentsSection
        externalReferenceNumberLabel="Seller's external reference (indent)"
        uploadedDocuments={uploadedDocuments}
      />
    </>
  );
};
